import { recipe } from "@vanilla-extract/recipes";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { colors } from "@/client/ui/design-system/styles/colors.css";
import { body2Css } from "@/client/ui/design-system/styles/typography.css";
import { px } from "@/client/utils/units";
import { borderRadius } from "@/client/ui/design-system/styles/border-radius.css";
import { spacing } from "@/client/ui/design-system/styles/spacing.css";

export const badge = recipe({
    base: {
        display: "flex",
        alignItems: "center",
        paddingLeft: spacing.xs,
        paddingRight: spacing.xs,
        paddingTop: px(2),
        paddingBottom: px(2),
        borderRadius: borderRadius.lg,
        ...body2Css,
    },

    variants: {
        variant: {
            default: {},
            error: {},
            success: {},
            warning: {},
            info: {},
        },
        theme: {
            light: {},
            dark: {},
        },
    },

    compoundVariants: [
        {
            variants: { variant: "default", theme: "light" },
            style: { backgroundColor: colors.gray05, color: colors.gray50 },
        },
        {
            variants: { variant: "error", theme: "light" },
            style: { backgroundColor: colors.red05, color: colors.red70 },
        },
        {
            variants: { variant: "success", theme: "light" },
            style: { backgroundColor: colors.green05, color: colors.green80 },
        },
        {
            variants: { variant: "warning", theme: "light" },
            style: { backgroundColor: colors.orange05, color: colors.orange80 },
        },
        {
            variants: { variant: "info", theme: "light" },
            style: { backgroundColor: colors.blue05, color: colors.blue70 },
        },
        {
            variants: { variant: "default", theme: "dark" },
            style: { backgroundColor: colors.gray70, color: colors.gray20 },
        },
        {
            variants: { variant: "error", theme: "dark" },
            style: { backgroundColor: colors.red05, color: colors.red70 },
        },
        {
            variants: { variant: "success", theme: "dark" },
            style: { backgroundColor: colors.green05, color: colors.green70 },
        },
        {
            variants: { variant: "warning", theme: "dark" },
            style: { backgroundColor: colors.orange05, color: colors.orange80 },
        },
        {
            variants: { variant: "info", theme: "dark" },
            style: { backgroundColor: colors.black, color: colors.blue70 },
        },
    ],

    defaultVariants: {
        variant: "default",
        theme: "light",
    },
});

export type BadgeVariants = RecipeVariants<typeof badge>;
